import { useGetters } from 'vuex-composition-helpers';
import getStore from '@fr/vue/services/getStore/getStore';
import registerModule from '@fr/vue/services/registerModule';
import HotelDescriptionRepository, {
    NAMESPACE,
} from '../model/HotelDescriptionRepository';
import { IHotelDescriptionUseGetters } from '../types';

export default function () {
    registerModule.register(getStore(), HotelDescriptionRepository, NAMESPACE);
    const {
        isNewHotelDescription,
        hotelDescriptionMainText,
        hotelDescriptionUpdateDate,
        hotelDescriptionTerritory,
        hotelDescriptionLocationAddress,
        hotelDescriptionImportant,
        hotelDescriptionFacilities,
        hotelDescriptionAirportName,
        hotelDescriptionAirportLocation,
        hotelDescriptionLocationDistance,
} = useGetters<IHotelDescriptionUseGetters>(NAMESPACE, ['isNewHotelDescription',
        'hotelDescriptionMainText',
        'hotelDescriptionUpdateDate',
        'hotelDescriptionTerritory',
        'hotelDescriptionLocationAddress',
        'hotelDescriptionImportant',
        'hotelDescriptionFacilities',
        'hotelDescriptionAirportName',
        'hotelDescriptionAirportLocation',
        'hotelDescriptionLocationDistance']);
    return {
        isNewHotelDescription,
        hotelDescriptionMainText,
        hotelDescriptionUpdateDate,
        hotelDescriptionTerritory,
        hotelDescriptionLocationAddress,
        hotelDescriptionImportant,
        hotelDescriptionFacilities,
        hotelDescriptionAirportName,
        hotelDescriptionAirportLocation,
        hotelDescriptionLocationDistance,
    };
}